import { Outlet, createFileRoute, redirect } from '@tanstack/react-router'
import { getAuthSession } from '@rpc/auth-session.rpc'
import Header from '../components/Header'
import Footer from '../components/Footer'

export const Route = createFileRoute('/dashboard')({
  beforeLoad: async () => {
    const session = await getAuthSession()
    if (!session?.user) {
      throw redirect({
        to: '/login',
      })
    }
    return { session }
  },
  component: DashboardLayout,
})

function DashboardLayout() {
  return (
    <div className="flex flex-col min-h-screen bg-neutral-50 dark:bg-neutral-950">
      <Header />
      <main id="main-content" className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  )
}
